import * as z from "zod";

export const getAovByChannel = {
  name: "getAovByChannel" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    channels: z.array(z.object({ channel: z.string(), aov: z.number() })),
  }),
};
